import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { productResponse } from "../types/products";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";

interface ShopProductsProps {
  products: productResponse[];
  url: string;
}

const ShopProducts: React.FC<ShopProductsProps> = ({ products, url }) => {
  const { t } = useTranslation();

  const [gridActivate, setGridActivate] = useState(true);
  const [listActivate, setListActivate] = useState(false);

  const setGridActive = () => {
    setGridActivate(true);
    setListActivate(false);
  };

  const setListActive = () => {
    setGridActivate(false);
    setListActivate(true);
  };

  return (
    <div className="shop-products-area">
      {/* shop layout switcher */}
      <div className="shop-layout-switcher text-end space-mt--15 space-mb--15">
        <div className="container">
          <button
            className={`${gridActivate ? "active" : ""}`}
            onClick={setGridActive}
          >
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/grid.svg"}
            />
          </button>
          <button
            className={`${listActivate ? "active" : ""}`}
            onClick={setListActive}
          >
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/list.svg"}
            />
          </button>
        </div>
      </div>

      {/* shop grid products */}
      <div
        className={`shop-grid-products-wrapper space-mb-m--20 ${
          gridActivate ? "d-block" : "d-none"
        }`}
      >
        <div className="container">
          <div className="row">
            {products &&
              products.map((single) => {
                return (
                  <div className="col-6" key={single.id}>
                    <div className="grid-product space-mb--20">
                      <div className="grid-product__image">
                        <Link
                          to={process.env.PUBLIC_URL + `${url}${single.id}`}
                        >
                          <img
                            src={process.env.PUBLIC_URL + single.imageUrl}
                            className="img-fluid"
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="grid-product__content">
                        <h3 className="title">
                          <Link
                            to={process.env.PUBLIC_URL + `${url}${single.id}`}
                          >
                            {single.name}
                          </Link>
                        </h3>
                        <span className="category">
                          {/*{single.category.map((item, index, arr) => {*/}
                          {/*  return (*/}
                          {/*    item + (index !== arr.length - 1 ? ", " : "")*/}
                          {/*  );*/}
                          {/*})}*/}
                        </span>
                        <span className="point">{single.pv} PV</span>
                        <div className="price">
                          <span className="discounted-price">{`${t("usd")} ${single.price}`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {/* shop list products */}
      <div
        className={`shop-list-products-wrapper ${
          listActivate ? "d-block" : "d-none"
        }`}
      >
        {products &&
          products.map((single) => {
            return (
              <div
                className="list-product border-bottom--medium"
                key={single.id}
              >
                <div className="list-product__image">
                  <Link to={process.env.PUBLIC_URL + `${url}${single.id}`}>
                    <img
                      src={process.env.PUBLIC_URL + single.imageUrl}
                      className="img-fluid"
                      alt=""
                    />
                  </Link>
                </div>
                <div className="list-product__content">
                  <h3 className="title">
                    <Link to={process.env.PUBLIC_URL + `${url}${single.id}`}>
                      {single.name}
                    </Link>
                  </h3>
                  <span className="point">{single.pv} PV</span>
                  <div className="price">
                    <span className="discounted-price">{`USD ${single.price}`}</span>
                  </div>
                  {single?.details && parse(single?.details)}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ShopProducts;
